var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtmScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.5C9.72369 1.5 9.49984 1.72386 9.49984 2C9.49984 2.27614 9.72369 2.5 9.99984 2.5H10.6665C12.2313 2.5 13.4998 3.76853 13.4998 5.33333V6C13.4998 6.27614 13.7237 6.5 13.9998 6.5C14.276 6.5 14.4998 6.27614 14.4998 6V5.33333C14.4998 3.21624 12.7836 1.5 10.6665 1.5H9.99984Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 1.5C3.21608 1.5 1.49984 3.21624 1.49984 5.33333V6C1.49984 6.27614 1.72369 6.5 1.99984 6.5C2.27598 6.5 2.49984 6.27614 2.49984 6V5.33333C2.49984 3.76853 3.76836 2.5 5.33317 2.5H5.99984C6.27598 2.5 6.49984 2.27614 6.49984 2C6.49984 1.72386 6.27598 1.5 5.99984 1.5H5.33317Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 7.5C0.390362 7.5 0.166504 7.72386 0.166504 8C0.166504 8.27614 0.390362 8.5 0.666504 8.5H15.3332C15.6093 8.5 15.8332 8.27614 15.8332 8C15.8332 7.72386 15.6093 7.5 15.3332 7.5H0.666504Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49984 10C2.49984 9.72386 2.27598 9.5 1.99984 9.5C1.72369 9.5 1.49984 9.72386 1.49984 10V10.6667C1.49984 12.7838 3.21608 14.5 5.33317 14.5H5.99984C6.27598 14.5 6.49984 14.2761 6.49984 14C6.49984 13.7239 6.27598 13.5 5.99984 13.5H5.33317C3.76836 13.5 2.49984 12.2315 2.49984 10.6667V10Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 10C14.4998 9.72386 14.276 9.5 13.9998 9.5C13.7237 9.5 13.4998 9.72386 13.4998 10V10.6667C13.4998 12.2315 12.2313 13.5 10.6665 13.5H9.99984C9.72369 13.5 9.49984 13.7239 9.49984 14C9.49984 14.2761 9.72369 14.5 9.99984 14.5H10.6665C12.7836 14.5 14.4998 12.7838 14.4998 10.6667V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmScan);
export default __webpack_public_path__ + "static/media/ATMScan.cfbee6fd9b4e6f581f23c1273110b98f.svg";
export { ForwardRef as ReactComponent };